"use strict";
import React from "react";
import { emailService } from "../services/email_service";
import WaitingSpinner from "../components/waiting_spinner";
function closeReply(props) {
  emailService.markComplete(null, false, props.emailId).then(() => {
    props.onComplete();
  });
}
var CloseReply = React.createClass({
  getInitialState: function() {
    return {
      closingReply: false
    };
  },
  render: function() {
    return /* @__PURE__ */ React.createElement(
      WaitingSpinner,
      {
        when: this.state.closingReply,
        "data-component": "CloseReply"
      },
      /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "button--progress",
          onClick: () => closeReply(this.props)
        },
        "Close Reply"
      )
    );
  }
});
export default CloseReply;
